import { EcpFieldNames } from "checkout-query-client/types/chex-form-fields";
import { FormConfig, InputType } from "checkout-query-client/types/form-types";

export enum BankAccountType {
  savings = "savings",
  checking = "checking",
  commercialChecking = "commercialChecking",
}

export const ecpFormConfig: FormConfig<EcpFieldNames> = {
  active: true,
  title: "eCheck",
  inputs: [
    {
      id: "accountType",
      type: InputType.select,
      active: true,
      initialValue: BankAccountType.checking,
      options: [
        {
          value: BankAccountType.checking,
          title: "accountType.checking",
        },
        {
          value: BankAccountType.savings,
          title: "accountType.savings",
        },
        {
          value: BankAccountType.commercialChecking,
          title: "accountType.commercialChecking",
        },
      ],
      grid: {
        small: {},
        medium: {},
        large: {},
      },
    },
    {
      id: "nameOnAccount",
      type: InputType.text,
      active: true,
      grid: {
        small: {},
        medium: {},
        large: {},
      },
    },
    {
      id: "routingNumber",
      type: InputType.text,
      active: true,
      grid: {
        small: {},
        medium: {},
        large: {},
      },
    },
    // Not needed if matching enabled out due to "matching" encrypted values
    {
      id: "confirmRoutingNumber",
      type: InputType.text,
      active: true,
      grid: {
        small: {},
        medium: {},
        large: {},
      },
    },
    {
      id: "accountNumber",
      type: InputType.text,
      active: true,
      grid: {
        small: {},
        medium: {},
        large: {},
      },
    },
    // Not needed if matching enabled out due to "matching" encrypted values
    {
      id: "confirmAccountNumber",
      type: InputType.text,
      active: true,
      grid: {
        small: {},
        medium: {},
        large: {},
      },
    },
    {
      id: "checkSampleImg",
      type: InputType.checkSampleImg,
      active: true,
      grid: {
        small: {},
        medium: {},
        large: {},
      },
    },
    {
      id: "billingTitle",
      type: InputType.subTitle,
      active: true,
      grid: {
        small: {
          marginTop: "2",
        },
        medium: {
          marginTop: "2",
        },
        large: {
          marginTop: "2",
        },
      },
    },
    {
      id: "doAddressesMatch",
      type: InputType.checkbox,
      initialValue: "true",
      active: true,
      grid: {
        small: {},
        medium: {},
        large: {},
      },
    },
    {
      id: "currentShippingAddress",
      type: InputType.currentAddress,
      initialValue: "",
      active: true,
      grid: {
        small: {
          marginTop: "-2",
          marginBottom: "2",
        },
        medium: {
          marginTop: "-2",
          marginBottom: "2",
        },
        large: {
          marginTop: "-2",
          marginBottom: "2",
        },
      },
    },
    {
      id: "billingAddressCountry",
      type: InputType.select,
      initialValue: "US",
      active: true,
      autocomplete: "country-name",
      grid: {
        small: {},
        medium: {},
        large: {},
      },
    },
    {
      id: "billingAddressAddressLine1",
      type: InputType.autocomplete,
      initialValue: "",
      active: true,
      autocomplete: "address-line1",
      grid: {
        small: {},
        medium: {},
        large: {},
      },
    },
    {
      id: "billingAddressAddressLine2",
      type: InputType.text,
      initialValue: "",
      active: true,
      autocomplete: "address-line2",
      grid: {
        small: {},
        medium: {},
        large: {},
      },
    },
    {
      id: "billingAddressCity",
      type: InputType.text,
      initialValue: "",
      autocomplete: "address-level2",
      active: true,
      grid: {
        small: {},
        medium: {},
        large: {},
      },
    },
    {
      id: "billingAddressAdministrativeArea",
      type: InputType.dynamic,
      initialValue: "",
      autocomplete: "address-level1",
      active: true,
      grid: {
        small: {
          flex: "0.5",
        },
        medium: {
          flex: "0.5",
        },
        large: {
          flex: "0.5",
        },
      },
    },
    {
      id: "billingAddressZip",
      type: InputType.text,
      initialValue: "",
      autocomplete: "postal-code",
      active: true,
      grid: {
        small: {
          flex: "0.5",
        },
        medium: {
          flex: "0.5",
        },
        large: {
          flex: "0.5",
        },
      },
    },
    {
      id: "collectConsentToStoreForFuturePayments",
      type: InputType.consentCheckbox,
      initialValue: "false",
      active: false,
      grid: {
        small: {},
        medium: {},
        large: {},
      },
    },
    {
      id: "setAsDefault",
      type: InputType.checkbox,
      initialValue: "false",
      active: false,
      grid: {
        small: {},
        medium: {},
        large: {},
      },
    },
  ],
};
